import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {MainModule} from "./main.module";

platformBrowserDynamic()
    .bootstrapModule(MainModule)
    .catch(console.error);